// extracted by mini-css-extract-plugin
export default {"modify_order_header":"fw","center":"gw","empty":"hw","pending":"iw","referralTitle":"jw","wrapper":"kw","title":"lw","tabs":"mw","tab":"nw","active":"ow","btn":"pw","rewards_table":"qw"};
    if(module.hot) {
      // 1713361650125
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  